import React from 'react';
import { PropTypes } from 'prop-types';
import Comments from './Comments';
import InternalReference from './InternalReference';
import AdditionalDocuments from './AdditionalDocuments';
import AppointmentInstructions from './AppointmentInstructions';

import cx from 'classnames';
import { useOrder } from 'hooks/useOrders';

const AdditionalOptions = ({
  className,
  orderId,
  shipmentId,
  isRecurring,
  internalReference,
  comments,
  appointmentInstructions,
  hideAdditionalDocuments,
  showInternalReference,
}) => {
  const { order } = useOrder(orderId, isRecurring);
  let safeComments = [];
  if (comments !== undefined && comments !== null) safeComments = comments;

  return (
    <div className={cx(className, 'small')} data-testid="additional-options">
      {appointmentInstructions && (
        <AppointmentInstructions value={appointmentInstructions} />
      )}
      <Comments comments={safeComments} />
      {showInternalReference && (
        <div data-testid="additional-options_internal-reference">
          <InternalReference
            value={internalReference}
            shipmentId={shipmentId}
            orderId={orderId}
            isRecurring={isRecurring}
          />
        </div>
      )}
      {!hideAdditionalDocuments && !isRecurring && (
        <AdditionalDocuments
          orderId={orderId}
          documents={order?.additional_documents}
          orderStatus={order?.status}
        />
      )}
    </div>
  );
};

AdditionalOptions.propTypes = {
  orderId: PropTypes.string.isRequired,
  shipmentId: PropTypes.string,
  isRecurring: PropTypes.bool,
  comments: PropTypes.string,
  internalReference: PropTypes.string,
  appointmentInstructions: PropTypes.string,
  hideAdditionalDocuments: PropTypes.bool,
};

AdditionalOptions.defaultProps = {
  isRecurring: false,
  hideAdditionalDocuments: false,
};

export default AdditionalOptions;
